export default __webpack_public_path__ + "static/media/chest-1.45d3da73.webp";